export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10686.dbb1e6c5.jpg";